export * from './lib/environments/environment';
